<template>
  <div class="p-16px">
    <Form mode="block" :model="model" :rules="validationRules" ref="form">
      <FormItem label="原密码" prop="original">
        <Input type="password" ref="original" v-model="model.original" @keyup.enter.native="focusNewPass"/>
      </FormItem>
      <FormItem label="新密码" prop="newPassword">
        <Input type="password" ref="newPassword" v-model="model.newPassword" @keyup.enter.native="focusRepeat"/>
      </FormItem>
      <FormItem label="重复密码" prop="repeatPassword">
        <Input type="password" ref="repeatPassword" v-model="model.repeatPassword" @keyup.enter.native="save"/>
      </FormItem>
      <FormItem>
        <Button @click="save" color="primary" :loading="isLoading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import CryptoJS from "crypto-js";
import {clone} from "xe-utils";

export default {
  name: "ChangePassword",
  data() {
    return {
      isLoading: false,
      model: {
        original: "",
        newPassword: "",
        repeatPassword: "",
      },
      validationRules: {
        required: ["original", "newPassword", "repeatPassword"],
        rules:{
          newPassword:{
            valid:{
              pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_][\x00-\xff]{7,19}$/,
              message: "密码必须包含大写字母、小写字母、数字、特殊字符中的三种，长度8到20位的半角字符"
            }
          }
        },
        combineRules: [
          //   {
          //   refs: ['original', 'newPassword'],
          //   valid(valueb,valuec){
          //     if(valueb == valuec){
          //       return "新密码不能和原密码一致";
          //     }
          //     return true;
          //   }
          // },
          {
            refs: ['newPassword', 'repeatPassword'],
            valid: {
              valid: 'equal',
              message: '两次输入的密码不一致'
            }
          }]
      }
    };
  },
  methods: {
    focusNewPass() {
      let validResult = this.$refs.form.validField('original');
      if (validResult.valid) {
        this.$refs.newPassword.$el.focus()
      }

    },
    focusRepeat() {
      let validResult = this.$refs.form.validField('newPassword');
      if (validResult.valid) {
        this.$refs.repeatPassword.$el.focus()
      }
    },
    save() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.isLoading = true;
        let params = clone(this.model, true)
        // params.original = CryptoJS.SHA256(params.original).toString(CryptoJS.enc.Hex);
        // params.newPassword = CryptoJS.SHA256(params.newPassword).toString(CryptoJS.enc.Hex);
        // params.repeatPassword = CryptoJS.SHA256(params.repeatPassword).toString(CryptoJS.enc.Hex);

        this.$api.common.updatePwd(this.model).then(() => {
          this.$Message('更新密码成功');
          this.isLoading = false;
          window.location.replace("/");
        }).catch(() => {
          this.isLoading = false;
        });
      }
    }
  },
  computed: {}
};
</script>
